<template>
	<v-navigation-drawer v-model="isExpandLeftMenu" temporary app dark>
		<v-layout class="pa-2" align-left justify-center column>
			<v-flex>
				<!-- <img :src="require('@/assets/duris.png')" width="100px"/> -->
				<!-- <span class="white--text">Firma Ďuriš</span> -->
			</v-flex>
		</v-layout>

		<!-- <v-divider dark class="mb-4"></v-divider> -->

		<v-list dense class="pt-0">
			<template v-for="(item, i) in items">
				<!-- HEADER FOR ITEMS -->
				<v-layout v-if="item.heading && $can(item.can[0], item.can[1])" :key="i">
					<v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
				</v-layout>

				<v-divider v-else-if="item.divider && $can(item.can[0], item.can[1])" :key="i" dark
					class="my-3"></v-divider>

				<v-list-tile v-else-if="$can(item.can[0], item.can[1])" :to="item.action" :key="i" class="pa-1">
					<v-list-tile-action>
						<v-icon>{{ item.icon }}</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title>{{ item.text }}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
			</template>
		</v-list>
	</v-navigation-drawer>
</template>

<script>
import * as types from "@/store/types";
export default {
	name: "LeftNavigation",
	data: () => ({
		items: [
			{ heading: "ĎURIŠ", can: ["read", "navigation"] },
			{
				icon: "home",
				text: "Domovská stránka",
				action: "/",
				can: ["read", "navigation"],
			},
			{
				icon: "perm_contact_calendar",
				text: "Kontaktujte nás",
				action: "/contact",
				can: ["read", "navigation"],
			},
			// {
			//   icon: "accessibility",
			//   text: "Služby",
			//   action: "/services",
			//   can: ["read", "navigation"]
			// },

			// { divider: true, can: ["read", "navigation"] },
			{ heading: "Nástroje", can: ["read", "navigation"] },
			{
				icon: "add",
				text: "Modelovanie",
				action: "/modeling/rozmery",
				can: ["manage", "admin"],
			},
			{
				icon: "perm_data_setting",
				text: "Rezanie materiálu",
				action: "/cutting",
				can: ["read", "navigation"],
			},
			{
				icon: "lightbulb_outline",
				text: "Databáza",
				action: "/database/dashboard",
				can: ["manage", "admin"],
			},

			// { divider: true, can: ["read", "cutting"] },
			{ heading: "Informácie", can: ["read", "navigation"] },
			// {
			//   icon: "info",
			//   text: "O Spoločnosti",
			//   action: "/about",
			//   can: ["read", "navigation"]
			// },

			{
				icon: "verified_user",
				text: "Ochrana osobných údajov",
				action: "/gdpr",
				can: ["read", "navigation"],
			},
			{
				icon: "work",
				text: "Obchodné podmienky",
				action: "/terms-and-conditions",
				can: ["read", "navigation"],
			},
			{
				icon: "shopping_basket",
				text: "Reklamačný poriadok",
				action: "/return-policy",
				can: ["read", "navigation"],
			},
			{
				icon: "settings_input_svideo",
				text: "Cookies",
				action: "/cookies",
				can: ["read", "navigation"],
			},
			{
				icon: "euro",
				text: "Projekt EU",
				action: "/projekt-eu",
				can: ["read", "navigation"],
			},
			{
				icon: "info",
				text: "Stroje a zariadenia",
				action: "/machines-and-equipment",
				can: ["read", "navigation"],
			},
			// {
			//   icon: "accessibility",
			//   text: "Váš názor nás zaujíma",
			//   action: "/j",
			//   can: ["read", "navigation"]
			// }
		],
	}),
	computed: {
		isAuthenticated() {
			if (this.$store.getters.isAuthenticated == undefined) return false;
			return this.$store.getters.isAuthenticated;
		},
		isExpandLeftMenu: {
			get() {
				return this.$store.getters.isExpandLeftMenu;
			},
			set(value) {
				this.$store.commit(types.EXPAND_LEFT_NAVIGATION, value);
			},
		},
	},
};
</script>

<style scoped></style>
